<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row justify-content-center">
              <!-- <div class="col-lg-6 d-none d-lg-block"></div> -->
              <div class="col-lg-6 col-md-9 col-sm-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">{{appname}} системд нэвтэрнэ үү!</h1>
                  </div>
                  <div class="user" autocomplete="off">
                    <div  v-if="loading==false">
                      <button @click="studentLogin" type="button" class="btn btn-primary btn-block">
                        <span v-if="grad!=null && grad!=undefined && grad==true">СУДЛААЧ</span>
                        <span v-else>Оюутан</span>
                      </button>
                      <button @click="teacherLogin" type="button" class="btn btn-google btn-block">
                        <span v-if="grad!=null && grad!=undefined && grad==true">ПРОФЕССОР</span>
                        <span v-else>Багш</span>
                        
                      </button>
                      <button @click="teacherLogin" type="button" class="btn btn-success btn-block">
                        АДМИН
                      </button>
                    </div>
                    <button type="button" v-else class="btn btn-google btn-block" disabled>
                      <span class="spinner-border spinner-border-sm"></span>
                      Loading..
                    </button>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
export default {
  name: "Adminman",
  data() {
    return {
      loading:false,
      appname:null,
      grad:false
    };
  },
  methods: {
    teacherLogin() {
      this.loading=true;
      this.$router.push('/teacherlogin');
    },
    studentLogin(){
      this.loading=true;
      this.$router.push('/studentlogin');

    }
  },
  created(){
    if(fb.APPNAME)
      this.appname=fb.APPNAME;
    if(fb.SHOW_GRAD_FORM)
      this.grad=fb.SHOW_GRAD_FORM;
  }
};
</script>

